import SlickVideoCollection from 'desktop/initializers/slick_video_collection';
import NativeComponentInitializers from 'shared/native_component_initializers';
import LocalStorageAdapter from 'shared/localstorage_adapter.js';
import PremierSlider from 'desktop/components/premier_slider';
import PlayCount from 'shared/components/play_count';
import { VidioHelpers } from 'shared/vidio_helpers';

export default class SectionsByAjax {
  constructor(options) {
    this.$container = options.$element;
    this.container = options.element;
    this.dataSource = this.container.dataset.source;
    this.cwStorage = LocalStorageAdapter.getItem('continue_watching');
  }

  init() {
    this.loadData();
  }

  loadData() {
    var section_id = this.getSectionId();
    var index = this.getIndex();
    var url = `/sections/${ section_id }.html?index=${ index }`;

    if(this.dataSource === 'continue_watching' && !this.validateStorageValue(this.cwStorage)) return;

    var fullUrl = url + this.continue_watching_ids();
    $.get(fullUrl)
      .done(data => { this.modifyElement(data); })
      .fail(e => {console.error(e);});
  }

  modifyElement(element) {
    try {
      var el = $.parseHTML(element)[0];
      var $element = $(el);

      if(this.hasContent($element)) {
        $element.find('.js-component').attr('data-loaded', true);
        this.$container.after($element);
        this.initSlick($element);
        new NativeComponentInitializers();
        PlayCount.load();
      }

      this.$container.remove();
    } catch(e) {
      console.error('CatchedSectionByAjax', e);
    }
  }

  hasContent($element) {
    return $element.find('#content-1').length > 0;
  }

  initSlick($element) {
    if (VidioHelpers.isMobile()) {
      return null;
    }

    if (this.getVariation() == 'portrait_horizontal') {
      var $slider = $element.find('[data-component="PremierSlider"]');
      new PremierSlider({$element: $slider, element: $slider[0]}).init();
    } else {
      SlickVideoCollection.init();
    }
  }

  continue_watching_ids() {
      var queryParams = (this.dataSource === 'continue_watching') ? `&cw=${ btoa(this.cwStorage) }` : '';
      return this.validateStorageValue(this.cwStorage) ? queryParams : '';
  }

  validateStorageValue(value) {
    try {
      JSON.parse(value);
      return true;
    } catch(e) {
      return false;
    }
  }

  getSectionId() {
    return this.container.dataset.sectionId;
  }

  getIndex() {
    return this.container.dataset.sectionIndex;
  }

  getVariation() {
    return this.container.dataset.sectionVariation;
  }
}
